module.exports = __webpack_public_path__ + "static/media/icon8.05e1bf2d.svg";